import { render, staticRenderFns } from "./OnboardingWhitelistIP.vue?vue&type=template&id=4540162a&scoped=true&lang=pug"
import script from "./OnboardingWhitelistIP.vue?vue&type=script&lang=ts"
export * from "./OnboardingWhitelistIP.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4540162a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
